// client-tournament.ts — HTTP client cho module giải đấu (@riptik/tournament-backoffice-module, ticket 107).
// Gọi bo-gateway `/organizers/:organizer/tournaments/<path>` → tournament-service. Response dạng { data: ... } (lỗi { error }),
// được deep-camelize như client-court; body gửi lên giữ nguyên snake_case.
import { getAuthToken, getBaseUrl } from './client';

const camel = (k: string): string => k.replace(/_([a-z0-9])/g, (_m, c: string) => c.toUpperCase());
function deepCamelize<T>(v: unknown): T {
  if (Array.isArray(v)) return v.map((x) => deepCamelize(x)) as unknown as T;
  if (v !== null && typeof v === 'object') {
    const out: Record<string, unknown> = {};
    for (const [k, val] of Object.entries(v as Record<string, unknown>)) out[camel(k)] = deepCamelize(val);
    return out as T;
  }
  return v as T;
}

const url = (org: string, path: string): string => `${getBaseUrl()}/organizers/${encodeURIComponent(org)}/tournaments/${path}`;

export async function tournamentRequest<T = unknown>(org: string, path: string, body?: Record<string, unknown>, method = 'POST'): Promise<T> {
  const token = getAuthToken();
  const res = await fetch(url(org, path), {
    method,
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  });
  const text = await res.text();
  const json = text ? JSON.parse(text) : undefined;
  if (!res.ok) throw Object.assign(new Error((json as { error?: string } | undefined)?.error || `tournament request failed (${res.status})`), { status: res.status });
  return deepCamelize<T>(json);
}

export async function tournamentDownload(org: string, path: string, filename: string): Promise<void> {
  const token = getAuthToken();
  const res = await fetch(url(org, path), { headers: token ? { Authorization: `Bearer ${token}` } : {} });
  if (!res.ok) throw new Error(`download failed (${res.status})`);
  const blob = await res.blob();
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(a.href);
}
